import city from '../../../assets/backgrounds/login/city_compressed.svg'
import {BackgroundContainer} from "./styled";

const AuthBackground = () => {
    function handleOnLoad(event: any) {
        event.target.style.opacity = 1
    }

    return (
        <BackgroundContainer src={city} alt={''} onLoad={(event) => handleOnLoad(event)}/>
    );
};

export default AuthBackground;
